<template>
  <div class="pricing-table">
    <div class="pricing-table__header"> 
      <div class="pricing-table__header-detail" v-if="dashboardSortUtility">

        <div class="pricing-table__head">{{ dashboardSortUtility.name }}</div>

        <div class="saved-figures"
          v-if="dashboardSortUtility.plan.slug != 'free'"
        >
          <div class="saved-figures__head">Price Requests:</div>
          <div class="saved-figures__figures" v-show="!loading">
            <div class="saved-figures__figure">
              <div class="saved-figures__value">{{ currentRequests }} </div>
              <div class="saved-figures__label">Saved</div>
            </div>
            <div class="saved-figures__figure"
              v-show="! ['premium', 'premium-legacy-1'].includes(dashboardSortUtility.plan.slug)"
            >
              <template v-if="dashboardSortUtility.plan.slug === 'free-registered' && remainingRequests == 0 && currentRequests == 0">&nbsp;</template>

              <template v-else>
                <div class="saved-figures__value">{{ remainingRequests }}</div>
                <div class="saved-figures__label">Remaining</div>
              </template>
            </div>
          </div>
        </div>

        <p class="sz-p" v-if="! ['premium', 'premium-legacy-1'].includes(dashboardSortUtility.plan.slug)"><a href="/account/subscription">Upgrade for more</a></p>   
      </div>

      <div class="pricing-table__header-actions">
        <!--
        <button class="btn btn-sm btn-secondary mrgn-right-0" @click.prevent="exportData">Export</button>
        <div class="pricing-table__toggle-wrap">
          <label for="unit-toggle">Display Units:</label>
          <select id="unit-toggle" v-model="unit">
            <option value="$/kWh">$/kWh</option>
            <option value="$">$</option>
          </select>
        </div>
        <button class="btn btn-sm btn-tertiary btn-icon mrgn-0 pad-right-0"
          @click="toggleExpandPricingTable"
        ><i class="fa fa-plus" 
          :class="{ 'fa-plus' : !expandAllPricingRows, 'fa-minus' : expandAllPricingRows }"
        ></i><span v-show="!expandAllPricingRows">Expand</span> <span v-show="expandAllPricingRows">Collapse</span> All Rows</button>
        -->
        <button class="actions-menu-btn"><i class="nav-icon"></i></button>
        <div class="actions-items">
          <ul>
            <li class="action-item">
              <a v-if="canExportData" href="#" class="action-item__button" role="button" @click.prevent="exportData">
                <i class="action-item__icon fa fa-download"></i> Export
              </a>
              <a v-else class="action-item__button" aria-disabled="true">
                <i class="action-item__icon fa fa-download"></i> Export
              </a>
            </li>
            <li class="action-item">
              <a href="#" class="action-item__button" role="button" @click.prevent="toggleExpandPricingTable">
                <i class="action-item__icon fa fa-plus" 
                  :class="{ 'fa-plus': !expandAllPricingRows, 'fa-minus': expandAllPricingRows }"
                ></i>
                <span v-show="!expandAllPricingRows">Expand</span> <span v-show="expandAllPricingRows">Collapse</span> All Rows 
              </a>
            </li>
            <li class="action-item">
              <a v-if="canSetDashboardEmailPush" href="#" class="action-item__button" role="button" @click.prevent="toggleEmailPushModal">
                <i class="action-item__icon fa fa-envelope"></i> Set Dashboard Email Push
              </a>
              <a v-else class="action-item__button" aria-disabled="true" @click.prevent="showPaywallModal">
                <i class="action-item__icon fa fa-envelope"></i> Set Dashboard Email Push
              </a>
            </li>
            <li class="action-item">
              <a href="#" class="action-item__button" role="button" @click.prevent="toggleUnits">
                <i class="action-item__icon fa fa-money"></i> Display {{ inactiveUnit }} Units
              </a>
            </li>
            <li class="action-item">
              <a href="#" class="action-item__button" role="button" @click.prevent="prepareNewPriceRequest">
                <i class="action-item__icon fa fa-plus"></i> Create New Price Request
              </a>
            </li>
            <li class="action-item">
              <a href="#" class="action-item__button" role="button" @click.prevent="toggleDashboardGuideModal">
                <i class="action-item__icon fa fa-plus"></i> Dashboard Guide
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="pricing-table__table-wrap" :class="{ 'pricing-table__table-wrap--no-scroll': !scrollingRequired }">
      <utility-dropdown @setDashboardSortUtility="setDashboardSortUtility"></utility-dropdown>

      <div class="pricing-table__scroll-container-x">
        <table class="pricing-table__table pricing-table__table--upper" cellpadding="0" cellspacing="0">
          <thead class="pricing-table__table-head">
            <tr class="pricing-table__subtable">
              <th class="pricing-table__cell pricing-table__cell--head pricing-table__cell--xsm">&nbsp;</th>
              <th class="pricing-table__cell pricing-table__cell--xl pricing-table__cell--head pricing-table__cell--head-sortable "
                @click="sortRowsByName"
              >Name <i class="fa fa-sort"></i></th>
              <th class="pricing-table__cell pricing-table__cell--head pricing-table__cell--sm-a pricing-table__cell--head-sortable"
                @click="sortRowsByStartDate"
              >Status <i class="fa fa-sort"></i></th>
              <th class="pricing-table__cell pricing-table__cell--head pricing-table__cell--table-parent">
                <table class="pricing-table__subtable">
                  <tbody>
                    <tr class="pricing-table__row">
                      <th class="pricing-table__cell pricing-table__cell--smed pricing-table__cell--head pricing-table__cell--head-sortable"
                        @click="sortRowsByStartDate"
                      >Start Month <i class="fa fa-sort"></i></th>
                      <th class="pricing-table__cell pricing-table__cell--head pricing-table__cell--sm">Term</th>
                      <th class="pricing-table__cell pricing-table__cell--head">Term Usage (kWh)</th>

                      <th class="pricing-table__cell pricing-table__cell--head pricing-table__cell--table-parent">
                        <table class="pricing-table__subtable">
                          <tbody>
                            <tr class="pricing-table__row">
                              <th class="pricing-table__cell pricing-table__cell--head pricing-table__cell--xl" colspan="3">Best Price Estimate (as of {{ currentDate }})</th>
                              <th class="pricing-table__cell pricing-table__cell--head pricing-table__cell--lrg" colspan="2">Alerts</th>
                            </tr>
                            <tr class="pricing-table__row">
                              <th class="pricing-table__cell pricing-table__cell--head">Component</th>
                              <th class="pricing-table__cell pricing-table__cell--head">{{ unit }}</th>
                              <th class="pricing-table__cell pricing-table__cell--head">WoW Change</th>
                              <th class="pricing-table__cell pricing-table__cell--no-wrap pricing-table__cell--smed pricing-table__cell--head">
                                {{ alertTrigger }} Trigger
                                <button class="btn btn-secondary btn-icon pricing-table__btn pricing-table__btn--invert pricing-table__btn--refresh"
                                  @click.prevent="toggleTrigger"
                                ><i class="fa fa-refresh"></i></button>
                              </th>
                              <th class="pricing-table__cell pricing-table__cell--head">Last Alert</th>
                            </tr>
                          </tbody>
                        </table>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </th>
              <th class="pricing-table__cell pricing-table__cell--xsm pricing-table__cell--head"></th>
            </tr>
          </thead>
        </table>
      </div>

      <div class="pricing-table__scroll-container-y">
        <table class="pricing-table__table pricing-table__table--lower">
          <template v-if="loading">
            <tbody class="pricing-table__table-body">
              <tr class="pricing-table__row">
                <td class="pricing-table__cell" colspan="5">
                  <div class="pricing-table__cell-spinner">
                    <ui-spinner/>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>

          <template v-if="!loading && filteredPricingRequests.length < 1">
            <tbody class="pricing-table__table-body">
              <tr class="pricing-table__row">
                <td class="pricing-table__cell" colspan="5">
                  <div class="tabpanel__tiny-spinner" v-show="loading">
                    <ui-spinner size="tiny" />
                  </div>

                  <i class="sz-k">No saved pricing requests</i>
                </td>
              </tr>
            </tbody>
          </template>

          <template v-else>
            <draggable 
              class="pricing-table__table-body" 
              v-model="reorderedPricingRequests" 
              tag="tbody"
              handle=".pricing-table__sort-handle"
              @end="saveRowOrder"
              item-key="id"
            >
              <template #item="{element, index}" v-if="filteredPricingRequests">
                <price-request-row 
                  :key="element.id"
                  :index="index"
                  :display-unit="unit"
                  :pricing-request="element"
                  :pricing-request-id="element.id"
                  :current-pricing-request-id="currentPricingRequestId"
                  :ordinal="index + 1"
                  :label="element.inputs.facilityProfileName"
                  :facility-profile="getFacilityProfileTypeName(element)"
                  :start-month="element.inputs.startMonth"
                  :term-length="element.inputs.termLength"
                  :volume="element.inputs.volume"
                  :primary-pricing-component="element.inputs.primaryPricingComponent"
                  :existing-supply-price="element.inputs.existingSupplyPrice"
                  :pricing-alerts="element.pricing_alerts"
                  :time-based-alerts="element.time_based_alerts"
                  :pricing-data="element.data"
                  :created="element.created_at"
                  :updated="element.updated_at"
                  :alert-trigger="alertTrigger"
                  :loading="loading"
                  @refreshPricingRequests="refreshPricingRequests"
                  @waitForUpdatedRequests="waitForUpdatedRequests"
                  @edit-notes="(priceRequest) => editNotes(priceRequest)"
                ></price-request-row>
              </template>
            </draggable>
          </template>

        </table>
      </div>
    </div>

    <dashboard-guide-modal
      @toggleDashboardGuideModal="toggleDashboardGuideModal"
      :modal-visible="dashboardGuideModalVisible"
    ></dashboard-guide-modal>

    <email-push-modal
      @toggleEmailPushModal="toggleEmailPushModal"
      :modal-visible="emailPushModalVisible"
    ></email-push-modal>

    <export-modal 
      @toggleExportModal="toggleExportModal"
      :modal-visible="exportModalVisible"
      :utility-id="dashboardSortUtility.id"
    ></export-modal>

    <notes-modal 
      @save="saveNotes"
      @close="closeNotesModal"
      :modal-visible="notesModalVisible"
      :price-request="selectedPriceRequest"
    ></notes-modal>

  </div>
</template>

<script>
import { nextTick } from 'vue'
import moment from 'moment-timezone'
import swal from 'sweetalert'
import Draggable from 'vuedraggable'
import UiSpinner from '../../../common/components/UiSpinner'
import UtilityDropdown from './UtilityDropdown.vue'
import PricingRow from './PricingRow.vue'
import EmailPushModal from './EmailPushModal.vue'
import ExportModal from './ExportModal.vue'
import DashboardGuideModal from './DashboardGuideModal.vue'
import NotesModal from './NotesModal.vue'

export default {
  components: {
    'draggable': Draggable,
    'utility-dropdown': UtilityDropdown,
    'price-request-row': PricingRow,
    'email-push-modal': EmailPushModal,
    'export-modal': ExportModal,
    'dashboard-guide-modal': DashboardGuideModal,
    'notes-modal': NotesModal,
    'ui-spinner': UiSpinner,
  },
  data() {
    return {
      unit: '$/kWh',
      alertTrigger: 'Low',
      nameSort: false,
      dateSort: false,
      selectedPriceRequest: null,
      reorderedPricingRequests: [],
      emailPushModalVisible: false,
      dashboardGuideModalVisible: false,
      exportModalVisible: false,
      notesModalVisible: false,
      localLoading: false,
      timer: null,
      loadingTimeout: 60000,
    }
  },
  computed: {
    loading() {
      return this.localLoading || 
             this.$store.getters.isLoadingSavedPriceRequests
    },
    currentDate() {
      let utcDate = moment().utc()

      if (this.timezone) {
        return moment(utcDate).tz(this.timezone).format('MM/DD/YYYY')
      }

      return moment(utcDate).local().format('MM/DD/YYYY')
    },
    userPlan() {
      return this.$store.getters.userPlan
    },
    timezone() {
      return this.$store.getters.userTimezone
    },
    planConfig() {
      return this.$store.getters.planConfig
    },
    savedPricingRequests() {
      return this.$store.getters.savedPricingRequests
    },
    canExportData() {
      return this.dashboardSortUtility.name
    },
    canSetDashboardEmailPush() {
      if (this.userPlan) {
        return ['basic', 'premium', 'premium-legacy-1'].includes(this.userPlan.slug)
      }
      return false
    },
    scrollingRequired() {
      // No filtered price requests, so no scrollbar needed.
      if (this.filteredPricingRequests.length <= 0) {
        return false

      // Free-Registered plan, so will never have enough 
      // price requests to need a scrollbar.
      } else if (this.dashboardSortUtility) {
        return this.dashboardSortUtility.plan.slug != 'free-registered'
      }

      // Default true.
      return true
    },
    filteredPricingRequests() {
      let pricingRequests = this.savedPricingRequests

      if (this.dashboardSortUtility) {
        pricingRequests = pricingRequests.filter(pricingRequest => pricingRequest.inputs.utilityMeta.id === this.dashboardSortUtility.id)
      }

      if (this.nameSort) {

        switch (this.nameSort) {
          case 'forward':
            pricingRequests.sort(function(a, b) {
              if (a.inputs.facilityProfileName < b.inputs.facilityProfileName || b.inputs.facilityProfileName === null) { 
                return -1;
              }

              if (a.inputs.facilityProfileName > b.inputs.facilityProfileName) { 
                return 1;
              }
              return 0;
            })
            break;

          case 'reverse':
            pricingRequests.sort(function(a, b) {
              if (a.inputs.facilityProfileName === null || a.inputs.facilityProfileName > b.inputs.facilityProfileName) { 
                return -1;
              }

              if (a.inputs.facilityProfileName < b.inputs.facilityProfileName) { 
                return 1;
              }
              return 0;
            })
            break;

          default: 
            break;
        }
      }

      if (this.dateSort) {

        switch (this.dateSort) {
          case 'forward':
            pricingRequests.sort(function(a, b) {
              if (a.inputs.startMonth < b.inputs.startMonth || b.inputs.facilityProfileName === null) { 
                return -1;
              }

              if (a.inputs.startMonth > b.inputs.startMonth) { 
                return 1;
              }
              return 0;
            })
            break;

          case 'reverse':
            pricingRequests.sort(function(a, b) {
              if (a.inputs.startMonth === null || a.inputs.startMonth > b.inputs.startMonth) { 
                return -1;
              }

              if (a.inputs.startMonth < b.inputs.startMonth) { 
                return 1;
              }
              return 0;
            })
            break;

          default: 
            break;
        }
      }

      this.reorderedPricingRequests = pricingRequests
      return pricingRequests
    },
    rowOrder() {
      let rowOrder = []

      if (this.reorderedPricingRequests.length) {
        rowOrder = this.reorderedPricingRequests.map(item => item.id)
      }
      return rowOrder
    },
    dashboardSortUtility() {
      return this.$store.getters.dashboardSortUtility
    },
    currentRequests() {
      return this.filteredPricingRequests.length
    },
    currentPricingRequestId() {
      return this.$store.getters.currentPricingRequest.savedPricingRequestId
    },
    remainingRequests() {
      if (this.planConfig.priceRequestSlots){
        if (this.dashboardSortUtility.plan && this.dashboardSortUtility.plan.slug === 'free-registered') {
          return 0
        }
        return (this.planConfig.priceRequestSlots - this.filteredPricingRequests.length)
      }
      return 0
    },
    expandAllPricingRows() {
      return this.$store.getters.expandAllPricingRows
    },
    inactiveUnit() {
      if (this.unit == '$/kWh') {
        return '$'
      }
      return '$/kWh'
    },
  },
  methods: {
    setDashboardSortUtility(utility) {
      console.log('--- setting utility ' + utility.id)
      this.$store.dispatch('setDashboardSortUtility', {
        code: utility.code,
        display_broker_fee: utility.display_broker_fee,
        id: utility.id,
        name: utility.name,
        pricing_req_count: utility.pricing_req_count,
        rate_classes_count: utility.rate_classes_count,
        state: utility.state,
        usage_levels_metric: utility.usage_levels_metric,
        visibility: utility.visibility,
      })
    },
    toggleExportModal() {
      this.exportModalVisible = !this.exportModalVisible
    },
    exportData() {
      this.toggleExportModal()

      // window.open('/pricing-calculator/me/inputs/' + this.dashboardSortUtility.id + '/export')

      // console.log('Export Data:', this.dashboardSortUtility)

      // axios.get('/pricing-calculator/me/inputs/' + this.dashboardSortUtility.id + '/export')
      //   .then(response => {
      //     console.log(response)
      //     let blob = new Blob([response.data], {type:response.headers.get('content-type')})
      //     let link = document.createElement('a')
      //     link.href = window.URL.createObjectURL(blob)
      //     link.download = response.headers.get('date')
      //     link.click()
      //   })
    },
    toggleEmailPushModal() {
      this.emailPushModalVisible = !this.emailPushModalVisible
    },
    toggleTrigger() {
      if (this.alertTrigger === 'Low') {
        this.alertTrigger = 'High'
        return
      }
      this.alertTrigger = 'Low'
    },
    toggleExpandPricingTable() {
      if (!this.expandAllPricingRows) {
        this.$store.dispatch('expandPricingTableRows')
        return
      } 
      this.$store.dispatch('collapsePricingTableRows')
    },
    toggleDashboardGuideModal() {
      this.dashboardGuideModalVisible = !this.dashboardGuideModalVisible
    },
    /**
     * Notes
     */
    editNotes(priceRequest) {
      this.selectedPriceRequest = priceRequest
      this.notesModalVisible = true
    },
    closeNotesModal() {
      this.notesModalVisible = false
      this.selectedPriceRequest = null
    },
    async saveNotes(priceRequest, payload) {
      try {
        await this.$store.dispatch('savePricingRequestNotes', {...payload, ...{id: priceRequest.id}})

      } catch (e) {
        console.error(e)
        swal('', 'An unexpected error occurred.', 'error')
      }
    },
    /**
     * Sorting
     */
    sortRowsByName() {
      this.dateSort = false

      if (!this.nameSort || this.nameSort === 'reverse') {
        this.nameSort = 'forward'

      } else if (this.nameSort === 'forward') {
        this.nameSort = 'reverse'
      }

      nextTick(() => {
        this.saveRowOrder()
      })
    },
    sortRowsByStartDate() {
      this.nameSort = false

      if (!this.dateSort || this.dateSort === 'reverse') {
        this.dateSort = 'forward'

      } else if (this.dateSort === 'forward') {
        this.dateSort = 'reverse'
      }

      nextTick(() => {
        this.saveRowOrder()
      })
    },
    saveRowOrder(e){
      let otherRequests = this.savedPricingRequests.filter(pricingRequest => pricingRequest.inputs.utilityMeta.id != this.dashboardSortUtility.id).map(item => item.id)
      let newOrder = this.rowOrder.concat(otherRequests)

      this.localLoading = true
      this.$store.dispatch('reordersavedPricingRequests', {
        ids: newOrder,
        utilityId: this.dashboardSortUtility.id
      })

      if (e && e.type === 'end') {
        this.nameSort = false
        this.dateSort = false
      }
    },
    toggleUnits() {
      if (this.unit == '$/kWh'){
        this.unit = '$'
      } else {
        this.unit = '$/kWh'
      }
    },
    prepareNewPriceRequest() {
      this.$store.dispatch('clearCurrentPricingRequest')
      this.$store.dispatch('clearAllFacilityData')
      this.$store.dispatch('clearAllOutputData')
      this.$store.dispatch('hoverOffSubmitPricingRequest')

      nextTick(() => {
        this.$store.dispatch('setView', 'workspace')
      })
    },
    showPaywallModal() {
      let msg = '<a href="/account/subscription">Subscription</a> required';
      if (this.dashboardSortUtility.name) {
        msg += ' for this utility:<br>' + this.dashboardSortUtility.name
      }

      let swalContent = document.createElement('div')
      swalContent.innerHTML = '<p>' + msg + '</p>'

      swal({
        content: swalContent,
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "",
            closeModal: true,
          }
        }
      })
    },
    scrollToLastRequest() {
      nextTick(() => {
        let container = document.querySelector('.wrap.dashboard .pricing-table__scroll-container-y')
        let item = document.querySelector('.wrap.dashboard .pricing-table__row--highlight')

        // Scroll to highlighted row.
        if (item) {
          container.scrollTop = item.offsetTop

        // Scroll to top.
        } else {
          container.scrollTop = 0
        }
      })
    },
    waitForUpdatedRequests() {
      this.localLoading = true

      this.timer = setTimeout(() => { 
        this.localLoading = false 
      }, this.localLoadingTimeout)
    },
    refreshPricingRequests() {
      this.$store.dispatch('clearSavedPricingRequests')
      this.localLoading = true

      this.timer = setTimeout(() => {
        this.localLoading = false
      }, this.localLoadingTimeout)

      this.fetchSavedPricingRequests()
    },
    fetchSavedPricingRequests() {
      this.$store.dispatch('fetchSavedPricingRequests')
    },
    getFacilityProfileTypeName(pricingRequest) {
      // Custom profile
      if (pricingRequest.inputs.customFacilityProfile && pricingRequest.inputs.customFacilityProfile.months) {
        if (
          pricingRequest.inputs.customFacilityProfileCategory &&
          pricingRequest.inputs.customFacilityProfileCategory.tier1
        ) {
          // Tier 1
          let tier1Name = pricingRequest.inputs.customFacilityProfileCategory.tier1.displayName 
            ? pricingRequest.inputs.customFacilityProfileCategory.tier1.displayName 
            : pricingRequest.inputs.customFacilityProfileCategory.tier1.name

          let text = 'Custom / ' + tier1Name

          // Tier 2
          let tier2Name = null
          if (
            pricingRequest.inputs.customFacilityProfileCategory.tier2 &&
            pricingRequest.inputs.customFacilityProfileCategory.tier2.facilityType
          ) {
            tier2Name = pricingRequest.inputs.customFacilityProfileCategory.tier2.facilityType.displayName 
              ? pricingRequest.inputs.customFacilityProfileCategory.tier2.facilityType.displayName 
              : pricingRequest.inputs.customFacilityProfileCategory.tier2.facilityType.name
          }

          if (tier2Name) {
            text += ': ' + tier2Name
          }

          return text

        } else {
          return '--Not Defined--'
        }
      }

      // Non-custom profile
      return pricingRequest.inputs.facilityTypeName
    }
  },
  activated() {
    this.nameSort = false
    this.dateSort = false
  },
  watch: {
    dashboardSortUtility(newUtility, oldUtility) {
      if (newUtility.id != oldUtility.id) {
        this.nameSort = false
        this.dateSort = false
        this.scrollToLastRequest()
      }
    },
    savedPricingRequests(n) {
      if (n.length) {
        this.localLoading = false

        this.scrollToLastRequest()
      }
    }
  },
  beforeRouteLeave(to, from, next){
    if (this.timer != null) {
      clearTimeout(this.timer)
    }
    next()
  }
}
</script>
